export default (key: string, fallback: string): string => {
  if (process.env[`REACT_APP_${key}`] !== '' || process.env[`REACT_APP_${key}`] !== undefined) {
    return process.env[`REACT_APP_${key}`] as string;
  }
  return fallback;
};
